export default "__VITE_ASSET__CP0w3ppJ__"